import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { selectDatabaseDraftByContentId } from '@databases/redux/changesets/selectors';
import { appStore } from '@databases/redux/store';
import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { DatabaseChangeType } from '@databases/types/redux';

import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

import {
  createCheckboxCellKeyboardInput,
  type CheckboxCellKeyboardInputDeps,
} from './create-checkbox-cell-keyboard-input.ts';

export interface CheckboxCellKeyboardInputFeatureDeps {
  contentId: string;
  sharedLoop: CheckboxCellKeyboardInputDeps['sharedLoop'];
  databaseAdapter: CheckboxCellKeyboardInputDeps['databaseAdapter'];
}

export function createCheckboxCellKeyboardInputFeature(
  deps: CheckboxCellKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.CHECKBOX_CELL_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE &&
      ctx.permissions.canEditContent &&
      getExperimentValue('checkboxFieldType', 'enabled', {
        fireExperimentExposure: false,
      }) === true &&
      getExperimentValue('databasesKeyboardA11y', 'isEnabled', {
        fireExperimentExposure: false,
      }) === true,
    factory: (machine) =>
      createCheckboxCellKeyboardInput(machine, {
        sharedLoop: deps.sharedLoop,
        databaseAdapter: deps.databaseAdapter,
        getDatabaseDraft: () =>
          selectDatabaseDraftByContentId(appStore.getState(), {
            contentId: deps.contentId,
            includeDeleted: true,
          }),
        setCheckboxValue: ({ fieldId, entryId, value }) => {
          appStore.dispatch(
            addChangeToDraft(deps.contentId, {
              type: DatabaseChangeType.SET_VALUE,
              fieldId,
              entryId,
              value: {
                type: DatabaseFieldType.CHECKBOX,
                value,
              },
              change: {
                type: DatabaseFieldType.CHECKBOX,
                value,
              },
            }),
          );
        },
      }),
  };
}
